import React from 'react'

import { Modal } from '@/components/ui'

import type { DeleteStatusModalProps } from '../types'

const DeleteStatusModal: React.FC<DeleteStatusModalProps> = ({
  show,
  statusName,
  onDelete,
  onCancel,
  isDeleting = false,
}) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      title="Delete Status"
      variation="danger"
      danger
      bodyContent={
        <p>
          Are you sure you want to delete the status <strong>"{statusName}"</strong>? This action cannot be undone.
        </p>
      }
      footerButtons={[
        {
          label: 'Delete',
          onClick: onDelete,
          disabled: isDeleting,
          useModalVariant: true,
          class: 'btn-error btn-sm',
          isLoading: isDeleting,
        },
        {
          label: 'Cancel',
          onClick: onCancel,
          disabled: isDeleting,
          class: 'btn-ghost btn-sm',
        },
      ]}
    />
  )
}

export default DeleteStatusModal
